import ExportMenu from "../../Common/ExportMenu/ExportMenu";
import { useRfidExcelExport } from "./ExportRfidExcel";
import { useRfidPdfExport } from "./ExportRfidPdf";

export const ExportRfid = ({ rfidData = [], extraItems = [] }) => {
  const { exportToExcel, isExporting: isExcelExporting } =
    useRfidExcelExport(rfidData);
  const { exportToPDF, isExporting: isPdfExporting } =
    useRfidPdfExport(rfidData);

  return (
    <ExportMenu
      items={[
        {
          label: "Excel",
          icon: "fa-solid fa-file-excel",
          onClick: exportToExcel,
          loading: isExcelExporting,
        },
        {
          label: "PDF",
          icon: "fa-solid fa-file-pdf",
          onClick: exportToPDF,
          loading: isPdfExporting,
        },
        ...extraItems,
      ]}
    />
  );
};
